import request from "@utils/request";
import { ParamsProps, ReturnType } from "./types";

const list = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: "transactions",
      method: "get",
      authorization: true,
      params: args?.params,
      config: {
        showErr: true,
      },
    };
    if (args.state) {
      config.config.store = {
        key: args?.state,
        action: "set",
      };
    }
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const settleCash = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: "transactions/cash-collections/settle",
      method: "post",
      authorization: true,
      data: args?.data,
      config: {
        successMsg: "Cash settled successfully",
        showErr: true,
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const getTransactionById = async (id: number) => {
  try {
    const config: ReturnType = {
      url: `transactions/${id}`,
      method: "get",
      authorization: true,
      config: {
        showErr: true,
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

export default {
  list,
  settleCash,
  getTransactionById,
};
